const HeightOffset = () => {
  return <div className="h-[80px]" />;
};

export default HeightOffset;
